// countries.js
export const countries = [
  { value: "USA", label: "United States of America" },
  { value: "AF", label: "Afghanistan" },
  { value: "AL", label: "Albania" },
  { value: "DZ", label: "Algeria" },
  { value: "AD", label: "Andorra" },
  { value: "AO", label: "Angola" },
  { value: "AI", label: "Anguilla" },
  { value: "AG", label: "Antigua & Barbuda" },
  { value: "AR", label: "Argentina" },
  { value: "AM", label: "Armenia" },
  { value: "AW", label: "Aruba" },
  { value: "AU", label: "Australia" },
  { value: "AT", label: "Austria" },
  { value: "AZ", label: "Azerbaijan" },
  { value: "BS", label: "Bahamas" },
  { value: "BH", label: "Bahrain" },
  { value: "BD", label: "Bangladesh" },
  { value: "BB", label: "Barbados" },
  { value: "BY", label: "Belarus" },
  { value: "BE", label: "Belgium" },
  { value: "BZ", label: "Belize" },
  { value: "BJ", label: "Benin" },
  { value: "BM", label: "Bermuda" },
  { value: "BT", label: "Bhutan" },
  { value: "BO", label: "Bolivia" },
  { value: "BA", label: "Bosnia & Herzegovina" },
  { value: "BW", label: "Botswana" },
  { value: "BR", label: "Brazil" },
  { value: "VG", label: "British Virgin Islands" },
  { value: "BN", label: "Brunei" },
  { value: "BG", label: "Bulgaria" },
  { value: "BF", label: "Burkina Faso" },
  { value: "BI", label: "Burundi" },
  { value: "CA", label: "Canada" },
  { value: "KH", label: "Cambodia" },
  { value: "CM", label: "Cameroon" },
  { value: "CV", label: "Cape Verde" },
  { value: "KY", label: "Cayman Islands" },
  { value: "TD", label: "Chad" },
  { value: "CL", label: "Chile" },
  { value: "CN", label: "China" },
  { value: "CO", label: "Colombia" },
  { value: "CG", label: "Congo" },
  { value: "CK", label: "Cook Islands" },
  { value: "CR", label: "Costa Rica" },
  { value: "CI", label: "Cote D'Ivoire" },
  { value: "HR", label: "Croatia" },
  { value: "CU", label: "Cuba" },
  { value: "CY", label: "Cyprus" },
  { value: "CZ", label: "Czech Republic" },
  { value: "DK", label: "Denmark" },
  { value: "DJ", label: "Djibouti" },
  { value: "DM", label: "Dominica" },
  { value: "DO", label: "Dominican Republic" },
  { value: "EC", label: "Ecuador" },
  { value: "EG", label: "Egypt" },
  { value: "SV", label: "El Salvador" },
  { value: "GQ", label: "Equatorial Guinea" },
  { value: "EE", label: "Estonia" },
  { value: "ET", label: "Ethiopia" },
  { value: "FK", label: "Falkland Islands" },
  { value: "FO", label: "Faroe Islands" },
  { value: "FJ", label: "Fiji" },
  { value: "FI", label: "Finland" },
  { value: "FR", label: "France" },
  { value: "PF", label: "French Polynesia" },
  { value: "WF", label: "French West Indies" },
  { value: "GA", label: "Gabon" },
  { value: "GM", label: "Gambia" },
  { value: "GE", label: "Georgia" },
  { value: "DE", label: "Germany" },
  { value: "GH", label: "Ghana" },
  { value: "GI", label: "Gibraltar" },
  { value: "GR", label: "Greece" },
  { value: "GL", label: "Greenland" },
  { value: "GD", label: "Grenada" },
  { value: "GU", label: "Guam" },
  { value: "GT", label: "Guatemala" },
  { value: "GG", label: "Guernsey" },
  { value: "GN", label: "Guinea" },
  { value: "GW", label: "Guinea Bissau" },
  { value: "GY", label: "Guyana" },
  { value: "HT", label: "Haiti" },
  { value: "HN", label: "Honduras" },
  { value: "HK", label: "Hong Kong" },
  { value: "HU", label: "Hungary" },
  { value: "IS", label: "Iceland" },
  { value: "IN", label: "India" },
  { value: "ID", label: "Indonesia" },
  { value: "IR", label: "Iran" },
  { value: "IQ", label: "Iraq" },
  { value: "IE", label: "Ireland" },
  { value: "IM", label: "Isle of Man" },
  { value: "IL", label: "Israel" },
  { value: "IT", label: "Italy" },
  { value: "JM", label: "Jamaica" },
  { value: "JP", label: "Japan" },
  { value: "JE", label: "Jersey" },
  { value: "JO", label: "Jordan" },
  { value: "KZ", label: "Kazakhstan" },
  { value: "KE", label: "Kenya" },
  { value: "KW", label: "Kuwait" },
  { value: "KG", label: "Kyrgyz Republic" },
  { value: "LA", label: "Laos" },
  { value: "LV", label: "Latvia" },
  { value: "LB", label: "Lebanon" },
  { value: "LS", label: "Lesotho" },
  { value: "LR", label: "Liberia" },
  { value: "LY", label: "Libya" },
  { value: "LI", label: "Liechtenstein" },
  { value: "LT", label: "Lithuania" },
  { value: "LU", label: "Luxembourg" },
  { value: "MO", label: "Macau" },
  { value: "MK", label: "Macedonia" },
  { value: "MG", label: "Madagascar" },
  { value: "MW", label: "Malawi" },
  { value: "MY", label: "Malaysia" },
  { value: "MV", label: "Maldives" },
  { value: "ML", label: "Mali" },
  { value: "MT", label: "Malta" },
  { value: "MR", label: "Mauritania" },
  { value: "MU", label: "Mauritius" },
  { value: "MX", label: "Mexico" },
  { value: "MD", label: "Moldova" },
  { value: "MC", label: "Monaco" },
  { value: "MN", label: "Mongolia" },
  { value: "ME", label: "Montenegro" },
  { value: "MS", label: "Montserrat" },
  { value: "MA", label: "Morocco" },
  { value: "MZ", label: "Mozambique" },
  { value: "NA", label: "Namibia" },
  { value: "NP", label: "Nepal" },
  { value: "NL", label: "Netherlands" },
  { value: "AN", label: "Netherlands Antilles" },
  { value: "NC", label: "New Caledonia" },
  { value: "NZ", label: "New Zealand" },
  { value: "NI", label: "Nicaragua" },
  { value: "NE", label: "Niger" },
  { value: "NG", label: "Nigeria" },
  { value: "NO", label: "Norway" },
  { value: "OM", label: "Oman" },
  { value: "PK", label: "Pakistan" },
  { value: "PS", label: "Palestine" },
  { value: "PA", label: "Panama" },
  { value: "PG", label: "Papua New Guinea" },
  { value: "PY", label: "Paraguay" },
  { value: "PE", label: "Peru" },
  { value: "PH", label: "Philippines" },
  { value: "PL", label: "Poland" },
  { value: "PT", label: "Portugal" },
  { value: "PR", label: "Puerto Rico" },
  { value: "QA", label: "Qatar" },
  { value: "RE", label: "Reunion" },
  { value: "RO", label: "Romania" },
  { value: "RU", label: "Russia" },
  { value: "RW", label: "Rwanda" },
  { value: "PM", label: "Saint Pierre & Miquelon" },
  { value: "WS", label: "Samoa" },
  { value: "SM", label: "San Marino" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "SN", label: "Senegal" },
  { value: "RS", label: "Serbia" },
  { value: "SC", label: "Seychelles" },
  { value: "SL", label: "Sierra Leone" },
  { value: "SG", label: "Singapore" },
  { value: "SK", label: "Slovakia" },
  { value: "SI", label: "Slovenia" },
  { value: "ZA", label: "South Africa" },
  { value: "KR", label: "South Korea" },
  { value: "ES", label: "Spain" },
  { value: "LK", label: "Sri Lanka" },
  { value: "KN", label: "St Kitts & Nevis" },
  { value: "LC", label: "St Lucia" },
  { value: "VC", label: "St Vincent" },
  { value: "SD", label: "Sudan" },
  { value: "SR", label: "Suriname" },
  { value: "SZ", label: "Swaziland" },
  { value: "SE", label: "Sweden" },
  { value: "CH", label: "Switzerland" },
  { value: "SY", label: "Syria" },
  { value: "TW", label: "Taiwan" },
  { value: "TJ", label: "Tajikistan" },
  { value: "TZ", label: "Tanzania" },
  { value: "TH", label: "Thailand" },
  { value: "TL", label: "Timor L'Este" },
  { value: "TG", label: "Togo" },
  { value: "TO", label: "Tonga" },
  { value: "TT", label: "Trinidad & Tobago" },
  { value: "TN", label: "Tunisia" },
  { value: "TR", label: "Turkey" },
  { value: "TM", label: "Turkmenistan" },
  { value: "TC", label: "Turks & Caicos" },
  { value: "UG", label: "Uganda" },
  { value: "UA", label: "Ukraine" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "GB", label: "United Kingdom" },
  { value: "UY", label: "Uruguay" },
  { value: "UZ", label: "Uzbekistan" },
  { value: "VE", label: "Venezuela" },
  { value: "VN", label: "Vietnam" },
  { value: "VI", label: "Virgin Islands (US)" },
  { value: "YE", label: "Yemen" },
  { value: "ZM", label: "Zambia" },
  { value: "ZW", label: "Zimbabwe" },
];
//languages
export const languages = [
    { value: "en", label: "English" },
    { value: "es", label: "Spanish" },
    { value: "sq", label: "Albanian" },
    { value: "am", label: "Amharic" },
    { value: "ar", label: "Arabic" },
    { value: "bn", label: "Bengali" },
    { value: "bs", label: "Bosnian" },
    { value: "my", label: "Burmese" },
    { value: "zh-CN", label: "Cantonese" },
    { value: "fa-af", label: "Dari" },
    { value: "fa", label: "Farsi" },
    { value: "fr", label: "French" },
    { value: "de", label: "German" },
    { value: "el", label: "Greek" },
    { value: "ht", label: "Haitian Creole" },
    { value: "he", label: "Hebrew" },
    { value: "hi", label: "Hindi" },
    { value: "hmn", label: "Hmong" },
    { value: "it", label: "Italian" },
    { value: "ja", label: "Japanese" },
    { value: "karen", label: "Karen" },
    { value: "km", label: "Khmer" },
    { value: "ko", label: "Korean" },
    { value: "lo", label: "Laotian" },
    { value: "lt", label: "Lithuanian" },
    { value: "zh", label: "Mandarin" },
    { value: "ne", label: "Nepali" },
    { value: "ps", label: "Pashto" },
    { value: "pl", label: "Polish" },
    { value: "pt", label: "Portuguese" },
    { value: "pa", label: "Punjabi" },
    { value: "ro", label: "Romanian" },
    { value: "ru", label: "Russian" },
    { value: "so", label: "Somali" },
    { value: "sw", label: "Swahili" },
    { value: "tl", label: "Tagalog" },
    { value: "th", label: "Thai" },
    { value: "ti", label: "Tigrigna" },
    { value: "tr", label: "Turkish" },
    { value: "uk", label: "Ukrainian" },
    { value: "ur", label: "Urdu" },
    { value: "vi", label: "Vietnamese" },
    { value: "other", label: "Other" },
  ];
  
//Ethnicities
  export const raceEthnicities = [
    { value: "american_indian", label: "American Indian or Alaska Native" },
    { value: "asian", label: "Asian" },
    { value: "black", label: "Black" },
    { value: "latino_hispanic", label: "Latino or Hispanic" },
    { value: "native_hawaiian", label: "Native Hawaiian or Pacific Islander" },
    { value: "white", label: "White" },
    { value: "other", label: "Other" },
    { value: "prefer_not_to_say", label: "Prefer Not to Say" },
  ];

  //currency
  export const currency = [
    { id: 1, name: "Afghan Afghani" },
    { id: 2, name: "Albanian Lek" },
    { id: 3, name: "Armenian Dram" },
    { id: 4, name: "Netherlands Antillean Guilder" },
    { id: 5, name: "Angolan Kwanza" },
    { id: 6, name: "Argentine Peso" },
    { id: 7, name: "Australian Dollar" },
    { id: 8, name: "Aruban Florin" },
    { id: 9, name: "Azerbaijani Manat" },
    { id: 10, name: "Bosnia-Herzegovina Convertible Mark" },
    { id: 11, name: "Barbadian Dollar" },
    { id: 12, name: "Bangladeshi Taka" },
    { id: 13, name: "Bulgarian Lev" },
    { id: 14, name: "Bahraini Dinar" },
    { id: 15, name: "Burundian Franc" },
    { id: 16, name: "Bermudan Dollar" },
    { id: 17, name: "Brunei Dollar" },
    { id: 18, name: "Bolivian Boliviano" },
    { id: 19, name: "Brazilian Real" },
    { id: 20, name: "Bahamian Dollar" },
    { id: 21, name: "Bitcoin" },
    { id: 22, name: "Bhutanese Ngultrum" },
    { id: 23, name: "Botswanan Pula" },
    { id: 24, name: "New Belarusian Ruble" },
    { id: 25, name: "Belarusian Ruble" },
    { id: 26, name: "Belize Dollar" },
    { id: 27, name: "Canadian Dollar" },
    { id: 28, name: "Congolese Franc" },
    { id: 29, name: "Swiss Franc" },
    { id: 30, name: "Chilean Unit of Account (UF)" },
    { id: 31, name: "Chilean Peso" },
    { id: 32, name: "Chinese Yuan" },
    { id: 33, name: "Colombian Peso" },
    { id: 34, name: "Costa Rican Colón" },
    { id: 35, name: "Cuban Convertible Peso" },
    { id: 36, name: "Cuban Peso" },
    { id: 37, name: "Cape Verdean Escudo" },
    { id: 38, name: "Czech Republic Koruna" },
    { id: 39, name: "Djiboutian Franc" },
    { id: 40, name: "Danish Krone" },
    { id: 41, name: "Dominican Peso" },
    { id: 42, name: "Algerian Dinar" },
    { id: 43, name: "Egyptian Pound" },
    { id: 44, name: "Eritrean Nakfa" },
    { id: 45, name: "Ethiopian Birr" },
    { id: 46, name: "Euro" },
    { id: 47, name: "Fijian Dollar" },
    { id: 48, name: "Falkland Islands Pound" },
    { id: 49, name: "British Pound Sterling" },
    { id: 50, name: "Georgian Lari" },
    { id: 51, name: "Guernsey Pound" },
    { id: 52, name: "Ghanaian Cedi" },
    { id: 53, name: "Gibraltar Pound" },
    { id: 54, name: "Gambian Dalasi" },
    { id: 55, name: "Guinean Franc" },
    { id: 56, name: "Guatemalan Quetzal" },
    { id: 57, name: "Guyanaese Dollar" },
    { id: 58, name: "Hong Kong Dollar" },
    { id: 59, name: "Honduran Lempira" },
    { id: 60, name: "Croatian Kuna" },
    { id: 61, name: "Haitian Gourde" },
    { id: 62, name: "Hungarian Forint" },
    { id: 63, name: "Indonesian Rupiah" },
    { id: 64, name: "Israeli New Sheqel" },
    { id: 65, name: "Manx Pound" },
    { id: 66, name: "Indian Rupee" },
    { id: 67, name: "Iraqi Dinar" },
    { id: 68, name: "Iranian Rial" },
    { id: 69, name: "Icelandic Króna" },
    { id: 70, name: "Jersey Pound" },
    { id: 71, name: "Jamaican Dollar" },
    { id: 72, name: "Jordanian Dinar" },
    { id: 73, name: "Japanese Yen" },
    { id: 74, name: "Kenyan Shilling" },
    { id: 75, name: "Kyrgystani Som" },
    { id: 76, name: "Cambodian Riel" },
    { id: 77, name: "Comorian Franc" },
    { id: 78, name: "North Korean Won" },
    { id: 79, name: "South Korean Won" },
    { id: 80, name: "Kuwaiti Dinar" },
    { id: 81, name: "Cayman Islands Dollar" },
    { id: 82, name: "Kazakhstani Tenge" },
    { id: 83, name: "Laotian Kip" },
    { id: 84, name: "Lebanese Pound" },
    { id: 85, name: "Sri Lankan Rupee" },
    { id: 86, name: "Liberian Dollar" },
    { id: 87, name: "Lesotho Loti" },
    { id: 88, name: "Mexican Peso" },
    { id: 89, name: "Malaysian Ringgit" },
    { id: 90, name: "Norwegian Krone" },
    { id: 91, name: "Nepalese Rupee" },
    { id: 92, name: "New Zealand Dollar" },
    { id: 93, name: "Omani Rial" },
    { id: 94, name: "Panamanian Balboa" },
    { id: 95, name: "Philippine Peso" },
    { id: 96, name: "Polish Zloty" },
    { id: 97, name: "Saudi Riyal" },
    { id: 98, name: "Swedish Krona" },
    { id: 99, name: "Singapore Dollar" },
    { id: 100, name: "United States Dollar" },
    { id: 101, name: "Vietnamese Dong" },
    { id: 102, name: "South African Rand" },
    { id: 103, name: "CFA Franc BCEAO" },
    { id: 104, name: "Yemeni Rial" },
    { id: 105, name: "Zimbabwean Dollar" }
  ];
  
  